module.exports = __webpack_public_path__ + "img/finished.bd0dc242.svg";